import { render, staticRenderFns } from "./SearchFormItem.vue?vue&type=template&id=48b198b3&scoped=true"
import script from "./SearchFormItem.vue?vue&type=script&lang=js"
export * from "./SearchFormItem.vue?vue&type=script&lang=js"
import style0 from "./SearchFormItem.vue?vue&type=style&index=0&id=48b198b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b198b3",
  null
  
)

export default component.exports